// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__23wEA","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1p0Y8"};